import React from 'react'
import { setMargin, setPadding } from '../../utilities'

export default function BioBanner ({
  pageName,
  first_name,
  last_name,
  image,
  margin_selection,
  padding_selection,
  background_color
}) {
  const pageStyles = {
    ...(background_color && {
      background:
        `linear-gradient(180deg, #EDC37800 0%, ${background_color} 100%)` ||
        'light-gray'
    }),
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  return (
    <div style={{ ...pageStyles }} className='w-full ' id={pageName}>
      <div className='speaker-container'>
        <section className='wrapper'>
          {first_name && <p className='first-name text-white'>{first_name}</p>}
          {image && (
            <img
              className='speaker'
              src={image?.url}
              alt='Portrait of a great Speaker'
              title='Shaun Derik'
            />
          )}
          {last_name && <p className='last-name text-white'>{last_name}</p>}
        </section>
      </div>
    </div>
  )
}
